
import generateGetActions from './generate';
import getDefinitionGetActions from './getDefinition';
import uiGetActions from './ui';

export * from './generate';
export * from './getDefinition';
export * from './ui';

export function getActions(dispatch) {
    return {
        ...generateGetActions(dispatch),
        ...getDefinitionGetActions(dispatch),
        ...uiGetActions(dispatch)
    }
}
